<module-container>
  <div class="title-container">
    <h2>Historical Line Item</h2>
  </div>

  <div class="form-fields-container" [formGroup]="formGroup">
    <mat-form-field appearance="fill">
      <mat-label>Store</mat-label>
      <input type="text" matInput formControlName="storeControl" [matAutocomplete]="autoStore" />
      <mat-autocomplete #autoStore="matAutocomplete">
        <mat-option *ngFor="let store of filteredStores | async" [value]="store.storeName">
          {{ store.storeName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="formGroup.get('storeControl').hasError('required')"
        >Store is required</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Supplier</mat-label>
      <input
        type="text"
        matInput
        formControlName="supplierControl"
        [matAutocomplete]="autoSupplier"
      />
      <mat-autocomplete #autoSupplier="matAutocomplete">
        <mat-option *ngFor="let supplier of filteredSupplier | async" [value]="supplier.label">
          {{ supplier.label }}
        </mat-option>
      </mat-autocomplete>
      <!-- Show error if Supplier or PLU is required and both are empty -->
      <mat-error
        *ngIf="
          formGroup.get('supplierControl').hasError('required') &&
          formGroup.get('supplierControl').touched
        "
      >
        Either Supplier or PLU is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>PLU</mat-label>
      <input type="text" matInput formControlName="pluControl" />
      <!-- Show error if PLU is required and both are empty -->
      <mat-error
        *ngIf="
          formGroup.get('pluControl').hasError('required') && formGroup.get('pluControl').touched
        "
      >
        Either Supplier or PLU is required
      </mat-error>
    </mat-form-field>
  </div>

  <div class="action-buttons-container">
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!isFormValid()">
      Search Historical Line Item
    </button>

    <button
      mat-raised-button
      color="accent"
      (click)="excludeHistoricalMatches()"
      [disabled]="!canApplyBulkAction()"
    >
      Exclude Historical Matching
    </button>

    <button
      mat-raised-button
      color="accent"
      (click)="excludeMultiplierMatches()"
      [disabled]="!canApplyBulkAction()"
    >
      Exclude Multiplier Matching
    </button>
  </div>

  <abcis-table *ngIf="tableVisible" [configuration]="tableConfig"></abcis-table>
</module-container>
